import React, { useEffect, useState } from "react";
import { Alert } from "antd";
// import { createPortal } from "react-dom";

const AlertComponent = () => {
  const [alertMessage, setAlertMessage] = useState<string | null>(null);

  useEffect(() => {

    const handleQuranOath = () => {
      setAlertMessage("Witness is taking oath by Quran");
      setTimeout(() => setAlertMessage(null), 5000);
    };
    
    const handleBibleOath = () => {
      setAlertMessage("Witness is taking oath by Bible");
      setTimeout(() => setAlertMessage(null), 5000);
    };

    const handleAffirm = () => {
      setAlertMessage("Witness affirmed");
      setTimeout(() => setAlertMessage(null), 5000);
    };

    const endOath = () => {
      setAlertMessage("Witness has finished swearing oath");
      setTimeout(() => setAlertMessage(null), 5000);
    };

    window.addEventListener("Quran-oath-taking-triggered", handleQuranOath);
    window.addEventListener("Bible-oath-taking-triggered", handleBibleOath);
    window.addEventListener("Affirm-oath-taking-triggered", handleAffirm);
    window.addEventListener("end-oath-triggered", endOath);


    return () => {
      window.removeEventListener("Quran-oath-taking-triggered", handleQuranOath);
      window.removeEventListener("Bible-oath-taking-triggered", handleBibleOath);
      window.removeEventListener("end-oath-triggered", endOath);
    };
  }, []);

  return (
    <>
      {alertMessage && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50">
          <Alert
            message={alertMessage}
            type="info"
            showIcon
            closable
            onClose={() => setAlertMessage(null)}
          />
        </div>
      )}
    </>
  );
};

export default AlertComponent;
